import { CloseNetworkIcon } from './CloseNetworkIcon';

/**
 * author: Austin Andrews
 * id 4043C369-E619-47E9-9363-E5E9C43457FB
 * name close-network
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-network.svg
 * tags
 */
export const MultiplyNetworkIcon = CloseNetworkIcon;
export default MultiplyNetworkIcon